import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, DataTable, LayoutGap } from '@gov-nx/ui/web';
import {
	generateArrayFromLength,
	generateRandomNumber,
} from '@gov-nx/utils/common';
import { CmsPageSkeleton } from '../../../../Cms/CmsPageSkeleton';

export const RezaTemplateDetailSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);

	return (
		<CmsPageSkeleton>
			<LayoutGap>
				<ContentLayout>
					<LayoutGap gap="m">
						<DataTable responsive>
							<tbody>
								{generateArrayFromLength(5).map((i) => (
									<tr key={i}>
										<td className="sm:w-1/2!">
											<GovSkeleton
												height="19px"
												width={generateRandomNumber(20, 70) + '%'}
												aria-label={t('loading.wcag.processing')}
											/>
										</td>
										<td>
											<GovSkeleton
												height="19px"
												width={generateRandomNumber(20, 70) + '%'}
												aria-label={t('loading.wcag.processing')}
												className="flex grow"
											/>
										</td>
									</tr>
								))}
							</tbody>
						</DataTable>
					</LayoutGap>
				</ContentLayout>
			</LayoutGap>
		</CmsPageSkeleton>
	);
};
